import { HomeCard } from 'azshared';
import React from 'react';
import { Loader, LoaderSize } from '../../../../components/loader/loader';
import { VideoPlayer } from '../../../../components/video-player/video-player';
import './home-azimut-for-you-card.scss';
import { VideoResponse } from 'azshared/src/lib/api/generated';

export const HomeAzimutForYouCard = (props: { video: HomeCard<VideoResponse> }) => {
  const { video } = props;
  return (
    <div className='home-azimut-for-you-card'>
      {video.requestStatus !== 'loading' && (
        <div className='home-azimut-for-you-card-video'>
          <VideoPlayer video={video.value?.videoUrl} />
        </div>
      )}
      {video.requestStatus === 'loading' && (
        <div className='home-azimut-for-you-card-loader'>
          <Loader loadersize={LoaderSize.XL} />
        </div>
      )}
    </div>
  );
};
